import React, { useState } from 'react';
import MainToolbar from '../MainToolbar';
import { t } from '../common/LocalizationProvider';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import { prefixString } from '../common/stringUtils';
import { formatBoolean } from '../common/formatter';
import SettingsDrawer from "../shared/SettingsDrawer";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  CssBaseline,
  useTheme, useMediaQuery,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Container from "@material-ui/core/Container";
import {cyberStyles} from "../cssShared/cyberTheme";

const useTableStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const usePageStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const NotificationsView = ({ updateTimestamp, onMenuClick }) => {
  const classes = useTableStyles();
  const [items, setItems] = useState([]);

  useEffectAsync(async () => {
    const response = await fetch('/api/notifications');
    if (response.ok) {
      setItems(await response.json());
    }
  }, [updateTimestamp]);

  const formatList = (prefix, value) => {
    if (value) {
      return value
          .split(/[, ]+/)
          .filter(Boolean)
          .map(it => t(prefixString(prefix, it)))
          .join(', ');
    }
    return '';
  };

  return (
      <TableContainer className={classes.container}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={clsx(classes.columnAction, classes.headerCell)} />
              <TableCell className={classes.headerCell}>{t('notificationType')}</TableCell>
              <TableCell className={classes.headerCell}>{t('allDevices')}</TableCell>
              <TableCell className={classes.headerCell}>{t('sharedAlarms')}</TableCell>
              <TableCell className={classes.headerCell}>{t('notificationNotificators')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
                <TableRow key={item.id} className={classes.row}>
                  <TableCell className={classes.columnAction} padding="none">
                    <IconButton onClick={(event) => onMenuClick(event.currentTarget, item.id)}>
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell style={{ fontWeight: 500 }}>{t(prefixString('event', item.type))}</TableCell>
                  <TableCell>{formatBoolean(item.always)}</TableCell>
                  <TableCell>{formatList('alarm', item.attributes.alarms)}</TableCell>
                  <TableCell>{formatList('notificator', item.notificators)}</TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
}

const NotificationsPage = () => {
  const classes = usePageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer
            hideDrawer={hideDrawer}
            setHideDrawer={setHideDrawer}
            page={'settings'}
        />

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} />

          <Container maxWidth="xl">
            <EditCollectionView
                content={NotificationsView}
                editPath="/settings/notification"
                endpoint="notifications"
            />
          </Container>
        </main>
      </div>
  );
}

// Note: Ensure 'clsx' or 'classnames' is available for the multiple classes on header icon cell
const clsx = (...args) => args.filter(Boolean).join(' ');

export default NotificationsPage;